import { render, staticRenderFns } from "./TechnicalDocumentation.vue?vue&type=template&id=0743cb1e&scoped=true"
import script from "./TechnicalDocumentation.vue?vue&type=script&lang=ts"
export * from "./TechnicalDocumentation.vue?vue&type=script&lang=ts"
import style0 from "./TechnicalDocumentation.vue?vue&type=style&index=0&id=0743cb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743cb1e",
  null
  
)

export default component.exports